import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppContextService, EcaAppShellModule } from '@drc-eca/eca-components-lib';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import {
  EcaPillarBoxModule,
  EcaFooterModule,
} from '@drc-eca/eca-components-lib';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EcaHeaderBaseComponent } from './components/eca-header-base/eca-header-base.component';
import { NotificationService } from './services/notification.service';

declare const gtag
@Component({
    selector: 'app-root',
    imports: [EcaHeaderBaseComponent, EcaPillarBoxModule, EcaFooterModule, FormsModule, ReactiveFormsModule, RouterOutlet, EcaAppShellModule],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private appContextSvc = inject(AppContextService);
  private router = inject(Router);
  notificationService = inject(NotificationService);
  title = 'app';
  tabs: any [] = [];
  headerVersion: string;
  showContent = false;

  constructor() {
    const router = inject(Router);

    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', 'G-T7WQX4K34F', {'page_path':e.urlAfterRedirects});
    })
  }


  ngOnInit () {
    this.appContextSvc.setPortalUrl(environment.portalUrl);
    if(window.location.href.toLocaleLowerCase().startsWith('https://wida-status')) {
      this.showContent = false;
    } else {
      this.showContent = true;
      sessionStorage.setItem('eca-enable-cache-buster', 'false');
      this.parseToken();
    }
  }

  parseToken(){
    this.appContextSvc.getToken().subscribe( token => {
      if (token && token !== ''){
        const helper = new JwtHelperService(); 
        const decodedToken = helper.decodeToken(token);
        sessionStorage.setItem('ngStorage-ecausername', decodedToken['username']);
      }
    });
  }
  
}
